import { SetStateAction } from 'react';
import ApolloClient, { gql } from "apollo-boost";
import authServices from "core/authentication/authService";
import axios from "axios";

export default class PipefyService {
  private BASE_URL = process.env.REACT_APP_PIPEFY_API_URL;

  private ORGANIZATION_ID = process.env.REACT_APP_PIPEFY_ORGANIZATION_ID;
  private getHeaders = async () => {
    return {
      authorization: `Bearer ${await this.getPipefyToken()}`,
    };
  };
  private apolloClient = new ApolloClient({
    uri: `${this.BASE_URL}/graphql`,
    request: async (operation) => {
      operation.setContext({ headers: await this.getHeaders() });
    },
  });

  private async getPipefyToken() {
    const credentials = new authServices().credentials();
    return credentials?.pipefy_token;
  }

  public async findPipe(pipeId: number) {
    return this.apolloClient.query({
      query: gql`{
        pipe(id: ${pipeId}) {
          name,
          phases {
            name,
            sequentialId
          }
        }
      }`,
    });
  }

  public async getPhases() {
    var result = await this.apolloClient.query({
      query: gql`{
        pipes(ids: [1254836,1266633]  ) {  
          name,
          phases {
            name,
            done
          }
        }
      }`,
    });

    var phases: any[] = [];

    result.data.pipes.forEach((pipe: { phases: any[]; }) => {
      pipe.phases.forEach((phase: any) => {
        const phaseExists = phases.findIndex(x => x.name === phase.name);

        if (phaseExists === -1 && phase.name !== "Novo") {
          phases.push(phase);
        }
      });
    });

    phases = phases.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      }

      if (a.name < b.name) {
        return -1;
      }

      return 0;
    });

    return phases;
  }

  public async findCard(cardId: number) {
    return this.apolloClient.query({
      query: gql`{
                card(id: ${cardId}) {
                  title
                  pipe {
                    id
                  }
                  currentLateness {  
                    id                
                    sla
                    becameLateAt
                    shouldBecomeLateAt
                  }
                  createdAt
                  started_current_phase_at
                  expiration {
                    expiredAt
                    shouldExpireAt
                  }
                  parent_relations {
                    pipe {
                      id,
                      phases{
                        name,
                        id
                      }
                    }
                  }
                  assignees {
                    id
                    email
                  }
                  comments {
                    text
                  }
                  comments_count
                  current_phase {
                    cards_can_be_moved_to_phases {
                      name
                      id
                      sequentialId
                    }
                    name
                    id,
                    sequentialId,
                    fields{
                      id,
                      label,
                      options,
                      required,
                      description,
                      type,
                      help
                    }
                  }
                  done
                  due_date
                  fields {
                    field {
                      id,
                      type,
                      options,
                      description
                    }
                    name
                    value
                  }
                  labels {
                    name
                  }
                  phases_history {
                    phase {
                      name,
                      fields{
                        id,
                        label,
                        type,
                        synced_with_card
                      }
                    }
                    
                    firstTimeIn
                    lastTimeOut,
                    lastTimeIn,
                    duration,
                    created_at,
                    became_late
                  }
                  url
                }
              }
              `
    });
  }

  public async updateCard(cardId: number | undefined, fieldId: string, fieldValue: any) {
    return this.apolloClient.mutate({
      mutation: gql`mutation changeCard($input: UpdateCardFieldInput!) {
        updateCardField(input: $input) {
         card {
           id
           title
           __typename
         }
         __typename
       }
     }`,
      variables: {
        input: {
          card_id: cardId,
          field_id: fieldId,
          new_value: fieldId === 'data_de_vig_ncia' && fieldValue === '' ? null : fieldValue
        }
      }
    });
  }

  public async createPresignedUrl(clientMutationId: string, fileName: string, contentType: string) {
    return this.apolloClient.mutate({
      mutation: gql`
      mutation{
  
        createPresignedUrl(input:{
          clientMutationId:"${clientMutationId}",
          organizationId:"${this.ORGANIZATION_ID}",
          fileName:"${fileName}",
          contentType:"${contentType}"
        })
        {
          clientMutationId,
          url
        }
      }
      `
    });
  }

  public async uploadFile(file: any, setProgress?: React.Dispatch<SetStateAction<number>>): Promise<string> {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      const namePart = file.name.substring(0, file.name.lastIndexOf("."));
      const extension = file.name.substring(file.name.lastIndexOf(".") + 1);

      const fileName = namePart.replace(/(\W+)/gi, '-') + "." + extension;

      this.createPresignedUrl(`updateCard`, fileName, file.type).then(result => {

        reader.onload = () => {
          const client = axios({
            baseURL: result.data.createPresignedUrl.url,
            method: "PUT",
            headers: {
              "Content-Type": file.type
            },
            data: new Blob([reader.result as ArrayBuffer]),
            onUploadProgress: (data: OnUploadProgressProps) => {
              if (setProgress)
                setProgress(Math.round((100 * data.loaded) / data.total));
            }
          });

          client.then(fileResult => {
            const url = result.data.createPresignedUrl.url as string;
            const finalUrl = decodeURIComponent(url.substr(0, url.indexOf('?')));
            resolve(finalUrl);
          });
          client.catch(error => {
            reject(error);
          });
        };
        reader.readAsArrayBuffer(file);
      });

    });
  }

  public async moveCard(cardId: number, destinationPhaseId: number, customResponse?: string) {
    return this.apolloClient.mutate({
      mutation: gql`
        mutation {
          moveCardToPhase(
            input: {
              card_id: ${cardId}
              destination_phase_id: ${destinationPhaseId}
            }
          ) {
          card {
            id
            fields {
              field {
                id
                type
                options
                description
              }
              name
              value
            }
            current_phase{
              name
              id,
              sequentialId,
              fields{
                id,
                label,
                options,
                description,
                type
              }             
            }           
          }
        }
      }`,
    });
  }
}
